<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <div class="search">
                <i class="fa-light fa-magnifying-glass" aria-hidden="true"></i>
                <input type="text" [(ngModel)]="search" [placeholder]="'categories_search_placeholder' | translate" autocomplete="off" />
            </div>
            <button class="add-btn" type="button" (click)="openAddModal()">{{ 'categories_add' | translate }}</button>
        </div>

        @if (loading) {
            <p class="state-text">{{ 'admin_loading' | translate }}</p>
        } @else if (categories.length === 0) {
            <p class="state-text">{{ 'categories_empty' | translate }}</p>
        } @else if (filteredCategories.length === 0) {
            <p class="state-text">{{ 'categories_no_match' | translate }}</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th>{{ 'field_category' | translate }}</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (c of filteredCategories; track c.id) {
                            <tr>
                                <td>
                                    @if (editingId === c.id) {
                                        <input class="edit-input" type="text" [(ngModel)]="editValue"
                                            (keyup.enter)="saveEdit(c)" />
                                    } @else {
                                        {{ c.categoryName }}
                                    }
                                </td>
                                <td class="actions-col">
                                    @if (editingId === c.id) {
                                        <button type="button" class="link-btn save" (click)="saveEdit(c)">{{ 'admin_action_save' | translate }}</button>
                                        <button type="button" class="link-btn cancel" (click)="cancelEdit()">{{ 'admin_action_cancel' | translate }}</button>
                                    } @else {
                                        <button type="button" class="icon-btn" (click)="startEdit(c)" [ngbTooltip]="'admin_action_edit' | translate" container="body">
                                            <fa-icon [icon]="faPen"></fa-icon>
                                        </button>
                                        <button type="button" class="icon-btn danger" (click)="remove(c)" [ngbTooltip]="'admin_action_delete' | translate" container="body">
                                            <fa-icon [icon]="faTrash"></fa-icon>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
